import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaCreditoDebito: moment(new Date()).format('YYYY-MM-DD'),
    bancoCuentaDebitoId: 0,
    bancoCuentaDebito: null,
    bancoCuentaDebitoNombre: null,
    monedaDebitoId: 0,
    monedaDebito: null,
    bancoCuentaCreditoId: 0,
    bancoCuentaCredito: null,
    bancoCuentaCreditoNombre: null,
    monedaCreditoId: 0,
    monedaCredito: null,
    importe: 0,
    cotizacion: 0
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.fechaCreditoDebito = moment(new Date()).format('YYYY-MM-DD');
        state.bancoCuentaDebitoId = 0;
        state.bancoCuentaDebito = null;
        state.bancoCuentaDebitoNombre = null;
        state.monedaDebitoId = 0;
        state.monedaDebito = null;
        state.bancoCuentaCreditoId = 0;
        state.bancoCuentaCredito = null;
        state.bancoCuentaCreditoNombre = null;
        state.monedaCreditoId = 0;
        state.monedaCredito = null;
        state.importe = 0;
        state.cotizacion = 0;
    },
    'SET_BANCO_CUENTA_DEBITO'(state, bancoCuenta) {
        state.bancoCuentaDebito = bancoCuenta;
        if (bancoCuenta) {
            state.bancoCuentaDebitoId = bancoCuenta.id ? bancoCuenta.id : 0;
            state.bancoCuentaDebitoNombre = bancoCuenta.nombre ? bancoCuenta.nombre.trim() : null;
            state.monedaDebitoId = bancoCuenta.monedaId ? bancoCuenta.monedaId : 0;
            state.monedaDebito = bancoCuenta.moneda ? bancoCuenta.moneda.trim() : null;
        } else {
            state.bancoCuentaDebitoId = 0;
            state.bancoCuentaDebitoNombre = null;
            state.monedaDebitoId = 0;
            state.monedaDebito = null;
        }
    },
    'SET_BANCO_CUENTA_CREDITO'(state, bancoCuenta) {
        state.bancoCuentaCredito = bancoCuenta;
        if (bancoCuenta) {
            state.bancoCuentaCreditoId = bancoCuenta.id ? bancoCuenta.id : 0;
            state.bancoCuentaCreditoNombre = bancoCuenta.nombre ? bancoCuenta.nombre.trim() : null;
            state.monedaCreditoId = bancoCuenta.monedaId ? bancoCuenta.monedaId : 0;
            state.monedaCredito = bancoCuenta.moneda ? bancoCuenta.moneda.trim() : null;
        } else {
            state.bancoCuentaCreditoId = 0;
            state.bancoCuentaCreditoNombre = null;
            state.monedaCreditoId = 0;
            state.monedaCredito = null;
        }
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');
            resolve();
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let bancoMovimientoDivisas = {
                fechaCreditoDebito: moment(state.fechaCreditoDebito).format('YYYY-MM-DD'),
                bancoCuentaDebitoId: parseInt(state.bancoCuentaDebitoId),
                bancoCuentaCreditoId: parseInt(state.bancoCuentaCreditoId),
                importe: parseFloat(state.importe),
                cotizacion: parseFloat(state.cotizacion),
            }

            apiAxios.post('bancosmovimientos/divisas', bancoMovimientoDivisas)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setBancoCuentaDebito: ({commit}, bancoCuenta) => {
        commit('SET_BANCO_CUENTA_DEBITO', bancoCuenta);
    },
    setBancoCuentaCredito: ({commit}, bancoCuentaCredito) => {
        commit('SET_BANCO_CUENTA_CREDITO', bancoCuentaCredito);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}